import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";

export const AddToCart_ProductVariant_Fragment = graphqlShopifyStorefront(
  `
  fragment AddToCart_ProductVariant on ProductVariant {
    id
    availableForSale
    compareAtPrice {
      amount
      currencyCode
    }
    price {
      amount
      currencyCode
    }
    selectedOptions {
      name
      value
    }
    sku
    title
    image {
      ...Image
    }
    requiresShipping
    taxable
    weight
  }
`,
  // [Image_Fragment],
);

export const AddToCart_ProductVariantConnectionMasked_Fragment =
  graphqlShopifyStorefront(
    `
  fragment AddToCart_ProductVariantConnectionMasked on ProductVariantConnection {
    edges {
      node {
        ...AddToCart_ProductVariant
      }
    }
  }
`,
    // [AddToCart_ProductVariant_Fragment],
  );

export const AddToCart_Product_Fragment = graphqlShopifyStorefront(
  `
  fragment AddToCart_Product on Product {
    availableForSale
    compareAtPriceRange {
      maxVariantPrice {
        amount
        currencyCode
      }
      minVariantPrice {
        amount
        currencyCode
      }
    }
    optionsMasked: options(first: 16) {
      ...ProductOption
    }
    priceRange {
      maxVariantPrice {
        amount
        currencyCode
      }
      minVariantPrice {
        amount
        currencyCode
      }
    }
    sellingPlanGroupsConnectionMasked: sellingPlanGroups(first:1) {
      edges {
        node {
          ...SellingPlanGroup
        }
      }
    }
    variantsConnectionMasked: variants(first: 64) {
      ...AddToCart_ProductVariantConnectionMasked
    }
  }
`,
  // [
  //   AddToCart_ProductVariantConnectionMasked_Fragment,
  //   ProductOption_Fragment,
  //   SellingPlanGroup_Fragment,
  // ],
);

export const Tracking_Product_Fragment = graphqlShopifyStorefront(
  `
  fragment Tracking_Product on Product {
    collectionsConnectionMasked: collections(first: $collectionsFirst) {
      edges {
        node {
          ...Collection
        }
      }
    }
    compareAtPriceRange {
      maxVariantPrice {
        amount
        currencyCode
      }
      minVariantPrice {
        amount
        currencyCode
      }
    }
    handle
    id
    priceRange {
      maxVariantPrice {
        amount
        currencyCode
      }
      minVariantPrice {
        amount
        currencyCode
      }
    }
    title
    vendor
  }
`,
  // [Collection_Fragment],
);

export const VariantSelector_Localization_Fragment = graphqlShopifyStorefront(
  `
  fragment VariantSelector_Localization on Localization {
    ...LinkedData_Localization
  }
`,
  // [LinkedData_Localization_Fragment],
);

export const VariantSelector_ProductVariant_Fragment = graphqlShopifyStorefront(
  `
  fragment VariantSelector_ProductVariant on ProductVariant {
    ...LinkedData_ProductVariant
    availableForSale
    id
    selectedOptions {
      name
      value
    }
  }
`,
  // [LinkedData_ProductVariant_Fragment],
);

export const VariantSelector_ProductVariantConnectionMasked_Fragment =
  graphqlShopifyStorefront(
    `
  fragment VariantSelector_ProductVariantConnectionMasked on ProductVariantConnection {
    edges {
      node {
        ...LinkedData_ProductVariant
        ...VariantSelector_ProductVariant
      }
    }
  }
`,
    // [
    //   LinkedData_ProductVariant_Fragment,
    //   VariantSelector_ProductVariant_Fragment,
    // ],
  );

export const VariantSelector_Product_Fragment = graphqlShopifyStorefront(
  `
  fragment VariantSelector_Product on Product {
    ...LinkedData_Product
    id
    collectionsConnectionMasked: collections(first: $collectionsFirst) {
      edges {
        node {
          ...Collection
        }
      }
    }
    compareAtPriceRange {
      maxVariantPrice {
        amount
        currencyCode
      }
      minVariantPrice {
        amount
        currencyCode
      }
    }
    priceRange {
      maxVariantPrice {
        amount
        currencyCode
      }
      minVariantPrice {
        amount
        currencyCode
      }
    }
    productType
    title
    variantsConnectionMasked: variants(first: 64) {
      ...VariantSelector_ProductVariantConnectionMasked
    }
    vendor
  }
`,
  // [
  //   Collection_Fragment,
  //   LinkedData_Product_Fragment,
  //   VariantSelector_ProductVariantConnectionMasked_Fragment,
  // ],
);
